import {BaseService} from './baseService.js';
import {Service} from './service.js';

/* 
 * Handles interaction with the App Script api
 */
export class AppScriptService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getAppScripts(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}	
		var data = await this.makeGETRequest('/api/resource/app-scripts' + params);		
		return data;
	}
	
	async getAppScript(scriptId) {		
		var data = await this.makeGETRequest('/api/resource/app-scripts/' + scriptId);		
		return data;
	}
	
	async runScriptSync(scriptId, appScriptFull) {	
		var result = await this.makePUTRequest('/api/resource/app-scripts/' + scriptId + '/run-sync', appScriptFull);
		return result;
	}	

	async runScriptAsync(scriptId, appScriptFull) {	
		var result = await this.makePUTRequest('/api/resource/app-scripts/' + scriptId + '/run-async', appScriptFull);
		return result;
	}
	
	async saveAppScript(appScript, edit) {
		var saved;
		if (edit) {
			saved = await this.makePUTRequest('/api/resource/app-scripts/' + appScript.scriptId, appScript);
		} else {
			saved = await this.makePOSTRequest('/api/resource/app-scripts', appScript);
		}
		return saved;
	}
	
	downloadOutput(scriptId) {			
		this.downloadFile('/api/resource/app-scripts/' + scriptId);		
	};	

	async deleteScript(scriptId) {		
		var result = await this.makeDELETERequest('/api/resource/app-scripts/'+ scriptId);		
		return result;
	}	
	
};